import $ from 'jquery';

const toggleSocialsInTVPopover = () => {

    const btnSelector = '.js-show-socials-in-tv-popover-btn';
    const wrapSelector = '.js-toggle-socials-in-tv-popover-wrap';
    const closeBtnSelector = '.js-close-socials-in-tv-popover-btn';
    const activeClass = 'active';

    $('body').on('click', btnSelector, function () {
        const $this = $(this);
        const parent = $this.closest(wrapSelector);
        parent.addClass(activeClass);
    });

    $('body').on('click', closeBtnSelector, function () {
        const $this = $(this);
        const parent = $this.closest(wrapSelector);
        parent.removeClass(activeClass);
    });
};

export default toggleSocialsInTVPopover;
